interface AboutCopy {
  title: string;
  paragraphs: string[];
}

export const ABOUT_COPY: AboutCopy = {
  title: 'ABOUT EMME',
  paragraphs: [
    "EMME is a marketplace connecting you with professional stylists for virtual and in-person sessions\u2014on your terms, on your budget, and at your pace. Whether you're building a wardrobe from scratch, navigating a life change, or just want to finally feel confident getting dressed, EMME makes expert style guidance accessible to everyone.",
    "For stylists, EMME is a home base to showcase your expertise, manage bookings, and grow a client base without the overhead. We're building toward a full suite of business tools so stylists can manage client relationships, track sessions, and scale their practice all in one place.",
    'We built EMME because great stylists exist everywhere \u2014 and so do people who need them. Our platform makes it easy to find, book, and work with a stylist who truly gets you.',
  ],
};
